import { FormEvent, ReactNode } from "react";

import { NeverValues } from "common/utils/types";

const noop = () => undefined;

type GeneralFormProps = {
  children: ReactNode;
  className?: string;
};

type FormSubmitProps = {
  /** if the form can be submitted or not, required if `onSubmit` is provided,
   * to ensure that unexpected submissions still go though the same validation
   * as a disabled submit button */
  canSubmit: boolean;
  onSubmit: () => void;
};

export type FormProps = GeneralFormProps & (FormSubmitProps | NeverValues<FormSubmitProps>);

/**
 * Form with a column layout that triggers callbacks instead of submitting the form to the server
 * or resetting to initial dom values
 */
const Form = ({ children, className, canSubmit = true, onSubmit = noop }: FormProps) => {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (canSubmit) {
      onSubmit();
    }
  };

  return (
    <form className={className} onSubmit={handleSubmit}>
      {children}
    </form>
  );
};

export default Form;
